import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

interface DialogSaveDraftProps extends Omit<DialogProps, 'children'> {
  isLoading?: boolean
  onClickConfirm?: () => any
  onClickCancel?: () => any
}

const DialogSaveDraft = ({
  isLoading,
  onClickConfirm = () => {},
  onClickCancel = () => {},
  ...props
}: DialogSaveDraftProps) => {
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent>
        <DialogCloseButton data-testid="btn-close" />
        <div className="p-6">
          <Text variant="display-sm">Simpan draf sebelum keluar?</Text>
          <Text variant="body-lg" color="subdued" className="mt-4">
            Pilihan Anda akan disimpan dan bisa dilanjutkan nanti. Pastikan draf
            diajukan sebelum batas waktu.
          </Text>

          <div className="flex gap-5 mt-5">
            <Button
              size="lg"
              className="w-[190px]"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={() => onClickConfirm()}
              data-testid="btn-confirm"
            >
              Simpan dan keluar
            </Button>
            <Button
              size="lg"
              color="white"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={() => onClickCancel()}
              data-testid="btn-cancel"
            >
              Kembali
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogSaveDraft
